import {Component, OnChanges, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {PartnersResource} from '../../model/model-resource';
import {AutofocusDirective} from '../../autofocus.directive';
import {Partner} from '../../model/partner';

@Component({
  selector: 'app-partner-seller-page',
  templateUrl: './partner-seller-page.component.html',
  styleUrls: ['./partner-seller-page.component.scss']
})
export class PartnerSellerPageComponent implements OnInit, OnChanges {

  partner: Partner;
  form: UntypedFormGroup;
  editMode = false;

  @ViewChild(AutofocusDirective) focus: AutofocusDirective;

  constructor(private builder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private partnersResource: PartnersResource) {
    this.form = this.builder.group({
      name: ['', Validators.required],
    });
  }

  editPartner() {
    this.editMode = true;
    this.focus.focus();
  }

  revertPartner() {
    this.ngOnChanges();
    if (this.partner.isNew()) {
      this.router.navigate(['/settings/partners', this.partner.parentPartnerId]);
    }
  }

  savePartner() {
    const formModel = this.form.value;
    const partner = this.partner.clone();
    partner.name = formModel.name;
    this.partnersResource.save(partner).subscribe((saved) => {
      this.partner = saved;
      this.ngOnChanges();
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.has('partnerSellerId')) {
        this.partnersResource.get(+params.get('partnerSellerId')).subscribe(partner => {
          this.partner = partner;
          this.ngOnChanges();
        });
      } else {
        this.partner = new Partner();
        this.partner.parentPartnerId = +params.get('partnerId');
        this.ngOnChanges();
      }
    });
  }

  ngOnChanges() {
    if (this.partner) {
      this.editMode = false;
      this.form.reset();
      this.form.patchValue(this.partner);
      if (this.partner.isNew()) {
        this.editMode = true;
        // this.focus.focus();
      }
    }
  }

}
